'use strict';

LocalizationModeHelper.$inject = ['$q', 'mx.shell.UserProfileService', 'mx.shell.InternationalizationService', 'mx.SolutionBuilderAgent.DialogOpenerService'];
export default function LocalizationModeHelper($q, userProfileService, i18nService, dialogOpener) {
	var dialogLocalizationModeClassName = 'mx-dialog-localization-mode';
	var baseLcid = 9;
	var customEditorInstances = {};

	return {
		dialogSelector: '.' + dialogLocalizationModeClassName + ':visible',
		enableMode: enableMode,
		disableMode: disableMode,
		applyStylesForControls: applyStylesForControls,
		isHtmlValueFilledIn: isHtmlValueFilledIn,
		getTranslatedValueByLcid: getTranslatedValueByLcid,
		removeStylesForControls: removeStylesForControls,
		preventUsualControlHandler: preventUsualControlHandler,
		getCurrentLanguage: getCurrentLanguage,
		openLocalizationDialog: openLocalizationDialog,
		getValueWithFallback: getValueWithFallback,
		applyTranslations: applyTranslations,
		getModelInfoFromElement: getModelInfoFromElement,
		registerCustomEditorInstance: registerCustomEditorInstance,
		destroyCustomEditorInstances: destroyCustomEditorInstances,
	};

	function enableMode(formElement) {
		formElement.addClass(dialogLocalizationModeClassName);
	}

	function disableMode(formElement) {
		removeStylesForControls();
		formElement.removeClass(dialogLocalizationModeClassName);
	}

	function applyStylesForControls(el, localizableModels, formCssSelector /*not mandatory*/) {
		var formCSS = '.' + dialogLocalizationModeClassName + (formCssSelector || '');
		el.append(
			'<style>' +
				localizableModels
					.map(function (modelStr) {
						return `${formCSS} mx-text-box[ng-model="${modelStr}"] md-input-container .md-input,
								${formCSS} mx-text-area[ng-model="${modelStr}"] textarea,
								${formCSS} mx-rich-text-box[ng-model="${modelStr}"] .mx-rich-text-box-fake,
								${formCSS} [value="${modelStr}"] > mx-rich-text-box .mx-rich-text-box-fake`;
					})
					.join(',') +
				' {' +
				'cursor: pointer;' +
				'border-color: #fc8529;' + // this is fallback for browsers that not support css variables
				'border-color: var(--theme-active-color);' +
				'}' +
				localizableModels
					.map(function (modelStr) {
						return (
							'' +
							formCSS +
							' mx-text-box[ng-model="' +
							modelStr +
							'"]::after, ' +
							formCSS +
							' mx-text-area[ng-model="' +
							modelStr +
							'"]::after, ' +
							formCSS +
							' mx-rich-text-box[ng-model="' +
							modelStr +
							'"]::after, ' +
							formCSS +
							' [value="' +
							modelStr +
							'"] > mx-rich-text-box::after'
						);
					})
					.join(',') +
				' {' +
				'display: block;' +
				'}' +
				'</style>'
		);
	}

	function isHtmlValueFilledIn(value) {
		return (
			$('<p>' + (value || '') + '</p>')
				.text()
				.trim() !== ''
		);
	}

	function getTranslatedValueByLcid(localizedField, lcid) {
		var translatedObject = localizedField.translations.filter(function (tr) {
			return tr.lcid === lcid;
		})[0];
		if (!translatedObject && lcid === baseLcid) {
			translatedObject = {
				lcid: baseLcid,
				value: localizedField.value,
			};
		}
		return isHtmlValueFilledIn(translatedObject && translatedObject.value) ? translatedObject.value : '';
	}

	function removeStylesForControls() {
		$('.mx-localization-controls-styles').remove();
	}

	function preventUsualControlHandler(event, localizableModels) {
		var allLocalizableControlsCssSelector = localizableModels
			.map(function (modelString) {
				return (
					'' +
					'mx-text-box[ng-model="' +
					modelString +
					'"], ' +
					'mx-text-area[ng-model="' +
					modelString +
					'"], ' +
					'mx-rich-text-box[ng-model="' +
					modelString +
					'"], ' +
					'[value="' +
					modelString +
					'"] > mx-rich-text-box'
				);
			})
			.join(',');
		var controlElm = $(event.target).filter(allLocalizableControlsCssSelector);
		if (controlElm.length === 0 && allLocalizableControlsCssSelector) {
			controlElm = $(event.target).parents(allLocalizableControlsCssSelector);
		}
		if (
			controlElm.length === 0 ||
			controlElm.find('input.md-input').is(':disabled') ||
			controlElm.find('input.md-input').prop('readonly') ||
			controlElm.find('.mx-rich-text-box-fake-disabled, .mx-rich-text-box-fake-readonly').length !== 0
		) {
			return;
		}

		event.stopPropagation();
		event.preventDefault();

		return controlElm;
	}

	function getCurrentLanguage() {
		return $q.all([userProfileService.get(), i18nService.getLanguages()]).then(function (res) {
			return res[1].filter(function (lang) {
				return lang.id.toLowerCase() === res[0].languageId.toLowerCase();
			})[0];
		});
	}

	function prepareValueTranslations(sourceCI, inputedVal, currentLang, fieldKey) {
		var incomingLangVals = [];

		for (var lcidKey in sourceCI) {
			if (sourceCI.hasOwnProperty(lcidKey) && lcidKey !== 'fields') {
				incomingLangVals.push({
					Lcid: Number(lcidKey),
					Value: Number(lcidKey) === currentLang.lcid ? inputedVal : sourceCI[lcidKey][fieldKey],
				});
			}
		}
		var currentIncomingLang = incomingLangVals.filter(function (lang) {
			return lang.Lcid === currentLang.lcid;
		})[0];
		var parentIncomingLang = incomingLangVals.filter(function (lang) {
			return lang.Lcid === currentLang.parentLcid;
		})[0];
		if (currentIncomingLang) {
			currentIncomingLang.Value = inputedVal;
		} else if (parentIncomingLang) {
			parentIncomingLang.Value = inputedVal;
		} else if (isHtmlValueFilledIn(inputedVal)) {
			incomingLangVals.push({
				Lcid: currentLang.parentLcid || currentLang.lcid,
				Value: inputedVal,
			});
		}

		return incomingLangVals;
	}

	function openLocalizationDialog(controlElm, currentValue, sourceCI, inputedVal) {
		var resParams = {};
		var modelInfo = getModelInfoFromElement(controlElm);
		return getCurrentLanguage()
			.then(function (currentLang) {
				resParams.currentLang = currentLang;
				var localizedValue = new mx.SolutionBuilderAgent.LocalizationProperty({
					Key: modelInfo.modelKey,
					Value: currentValue,
					Translations: prepareValueTranslations(sourceCI, inputedVal, currentLang, modelInfo.fieldKey),
				});
				localizedValue.id = modelInfo.modelKey;

				var customEditor = customEditorInstances[modelInfo.modelKey];
				var getTitleForLocalization =
					(customEditor && customEditor.getTitleForLocalization) ||
					function () {
						return controlElm.find('label > span').text() || controlElm.find('label').text();
					};
				return dialogOpener.openLocalizationDialog({
					saveLocalizationDirectly: false,
					title: getTitleForLocalization(),
					richTextMode: controlElm[0].tagName === 'MX-RICH-TEXT-BOX',
					localizedValue: localizedValue,
					customEditor: customEditor,
				});
			})
			.then(function (localizedField) {
				resParams.localizedField = localizedField;
				return resParams;
			});
	}

	function getValueWithFallback(localizedField, currentLang) {
		return getTranslatedValueByLcid(localizedField, currentLang.lcid) || getTranslatedValueByLcid(localizedField, currentLang.parentLcid);
	}

	function applyTranslations(localizedField, fieldKey, resultCIObject) {
		// clean up old values
		for (var k in resultCIObject) {
			if (resultCIObject.hasOwnProperty(k) && parseInt(k, 10) + '' === k + '' /*if it's number*/) {
				resultCIObject[k][fieldKey] = null;
			}
		}
		// init base lang translation

		var baseLangTranslation = _.find(localizedField.translations, { lcid: baseLcid });
		var translations = localizedField.translations.slice(0);
		if (!baseLangTranslation) {
			translations.push({
				lcid: baseLcid,
				value: localizedField.value,
			});
		}
		// adding new or updating old translated field
		translations.forEach(function (trVal) {
			if (isHtmlValueFilledIn(trVal.value)) {
				resultCIObject[trVal.lcid] = resultCIObject[trVal.lcid] || {};
				resultCIObject[trVal.lcid][fieldKey] = trVal.value;
			}
		});
		return resultCIObject;
	}

	function getModelInfoFromElement(controlElm) {
		var modelInfo = {};
		modelInfo.modelKey = controlElm.attr('ng-model');
		if (modelInfo.modelKey === 'vm.value') {
			modelInfo.modelKey = controlElm.parent('[value]').attr('value');
		}
		modelInfo.modelPath = modelInfo.modelKey.split('.');
		modelInfo.fieldKey = modelInfo.modelPath[modelInfo.modelPath.length - 1];
		return modelInfo;
	}

	function registerCustomEditorInstance(modelKey, editorType, params, modelAttrKey, getTitleForLocalizationFn) {
		customEditorInstances[modelKey] = {
			editorType: editorType,
			params: params,
			modelAttrKey: modelAttrKey,
			getTitleForLocalization: getTitleForLocalizationFn,
		};
	}

	function destroyCustomEditorInstances() {
		customEditorInstances = {};
	}
}
